// extracted by mini-css-extract-plugin
export default {"seeds":"style_seeds__lWVgc","icon":"style_icon__T+waV","seed":"style_seed__CysbV","name":"style_name__23OAN"};